import defaultSettings from "@/config";
const { title } = defaultSettings;
const state = {
  logo: "",
  title,
  loading: false,
  asscessGamesList: [],
  token: "",
  languages: [],
  roles: null,
  userInfo: null,
  gameCodeList: null,
  currentGamgeCode: "",
  isFirst: true,
  drawerVisble: false
};
const getters = {
  logo: stateGetter => state.logo,
  loading: stateGetter => state.loading,
  asscessGamesList: stateGetter => state.asscessGamesList,
  token: stateGetter => state.token,
  languages: stateGetter => state.languages,
  roles: stateGetter => state.roles,
  currentGamgeCode: stateGetter => state.currentGamgeCode,
  isFirst: stateGetter => state.isFirst
};
const actions = {
  loadingChange({ commit }) {
    commit("loadingChange");
  },
  asscessGamesListChange({ commit }) {
    commit("asscessGamesListChange");
  },
  tokenChange({ commit }) {
    commit("tokenChange");
  },
  languagesChange({ commit }) {
    commit("languagesChange");
  },
  rolesChange({ commit }) {
    commit("rolesChange");
  },
  userInfoChange({ commit }) {
    commit("userInfoChange");
  },
  currentGamgeCodeChange({ commit }) {
    commit("currentGamgeCodeChange");
  },
  isFirstChange({ commit }) {
    commit("isFirstChange");
  },
  drawerVisbleChange({ commit }) {
    commit("drawerVisbleChange");
  }
};
const mutations = {
  loadingChange(newState, loading) {
    newState.loading = loading;
  },
  asscessGamesListChange(newState, asscessGamesList) {
    newState.asscessGamesList = asscessGamesList;
  },
  tokenChange(newState, token) {
    newState.token = token;
  },
  languagesChange(newState, languages) {
    newState.languages = languages;
  },
  rolesChange(newState, roles) {
    newState.roles = roles;
  },
  userInfoChange(newState, userInfo) {
    newState.userInfo = userInfo;
  },
  gameCodeListChange(newState, gameCodeList) {
    newState.gameCodeList = gameCodeList;
  },
  currentGamgeCodeChange(newState, currentGamgeCode) {
    newState.currentGamgeCode = currentGamgeCode;
  },
  isFirstChange(newState, isFirst) {
    newState.isFirst = isFirst;
  },
  drawerVisbleChange(newState, drawerVisble) {
    newState.drawerVisble = drawerVisble;
  }
};
export default { state, getters, mutations, actions };
